import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import VueApollo from "vue-apollo";
import apolloClient from "./vue-apollo";
//plugins
import NowUIKit from './plugins/now-ui-kit';
import VueShowdown from 'vue-showdown'
import AudioVisual from 'vue-audio-visual'

Vue.config.productionTip = false;
Vue.use(VueApollo);
Vue.use(NowUIKit);
Vue.use(VueShowdown, {
  options: {
    emoji: true
  }
})
Vue.use(AudioVisual)

Vue.prototype.$frontenddAddress = 'http://localhost:1337'
// Vue.prototype.$frontenddAddress = 'https://www.tihenhoca.com'

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});
new Vue({
  apolloProvider,
  router,
  render: h => h(App)
}).$mount("#app");
